export const environment = {
	production: true,
	//AUTH_URL: 'http://52.168.86.247:8083/api/auth/',
	//BASE_URL: 'http://52.168.86.247:8083/',

	//AUTH_URL: 'https://localhost:8082/api/auth/',
	//BASE_URL: 'https://localhost:8082/',

	AUTH_URL: 'https://contrackmanagementgroup.com:8082/api/auth/', //prod
    BASE_URL: 'https://contrackmanagementgroup.com:8082/',

	//AUTH_URL: 'https://testing.contrackmanagementgroup.com:8083/api/auth/',
	//BASE_URL: 'https://testing.contrackmanagementgroup.com:8083/',
	baseHref: '/'
};
